<template>
	<div class="con">
		<div class="header">
			<h1>预约挂号</h1>
			<p>请选择就诊科室</p>
		</div>
		
		<div class="list" v-if="list.length != ''">
			<div class="list-right">
				<div class="list-con" v-for="(item,index) in list" @click="toRegDeta(index)" :key="index">
					<div class="department-info">
						<div class="department-name">{{item.KSMC}}</div>
						<div class="department-remark" v-if="item.REMARK">{{item.REMARK}}</div>
					</div>
					<van-icon name="arrow" color='#999' />
				</div>
			</div>
		</div>
		
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">暂无科室数据</div>
			<div class="no-subtext">请稍后重试或联系医院</div>
		</div>
		
		<div class="loading" v-if="loading">
			<van-loading type="spinner" color="#27BEC4" />
			<div class="loading-text">加载科室中...</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'registered',
		data() {
			return {
				msg: '挂号预约',
				list: [],
				noImgShow: false,
				loading: true,
			}
		},
		methods: {
			//类目详情
			toRegDeta(e) {
				let data = {
					ksdm: this.list[e].KSDM,
					ksmc: this.list[e].KSMC,
					REMARK: this.list[e].REMARK,
				}
				this.$router.push({
					path: 'registeredDeta',
					query: data
				})
				
			},
			//获取科室
			GetOffice() {
				this.loading = true;
				this.noImgShow = false;
				this.$store.commit('Load', true)
				this.$Axios.Get('/outpatient/office?yjks=01&xsyy=1', null).then(data => {
					this.$store.commit('Load', false)
					this.loading = false;
					console.log(data)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							this.noImgShow = false;
							this.list = data.msg;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}

				}).catch(err => {
					this.noImgShow = true;
					this.loading = false;
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
		},
		mounted() {
			this.GetOffice();
		}
	}
</script>

<style scoped>
	.con {
		min-height: 100vh;
		background-color: #f5f7fa;
		padding-bottom: 30px;
	}
	
	.header {
		background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
		padding: 15px;
		color: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
		position: sticky;
		top: 0;
		z-index: 100;
	}
	
	.header h1 {
		font-size: 18px;
		font-weight: 700;
		margin: 0 0 5px 0;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
	}
	
	.header p {
		font-size: 14px;
		margin: 0;
		opacity: 0.9;
	}
	
	.list {
		flex: 1;
		overflow-y: auto;
	}
	
	.list-right {
		padding: 0 15px;
	}
	
	.list-con {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		margin-bottom: 10px;
		background: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 10px rgba(0,0,0,0.08);
		transition: all 0.3s ease;
		cursor: pointer;
	}
	
	.list-con:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 16px rgba(0,0,0,0.12);
	}
	
	.department-info {
		flex: 1;
		margin-right: 15px;
	}
	
	.department-name {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		margin-bottom: 5px;
	}
	
	.department-remark {
		font-size: 14px;
		color: #666;
		line-height: 1.4;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
		padding: 0 20px;
	}
	
	.no-text {
		margin-top: 15px;
		color: #27BEC4;
		font-size: 18px;
		font-weight: 600;
	}
	
	.no-subtext {
		margin-top: 8px;
		color: #999;
		font-size: 14px;
	}
	
	.loading {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 20vh;
		padding: 0 20px;
	}
	
	.loading-text {
		margin-top: 15px;
		font-size: 14px;
		color: #666;
	}
	
	/* 响应式设计 */
	@media (max-width: 768px) {
		.header {
			padding: 20px 15px;
		}
		
		.header h1 {
			font-size: 20px;
		}
		
		.list-right {
			padding: 0 10px;
		}
		
		.list-con {
			padding: 15px;
		}
		
		.department-name {
			font-size: 16px;
		}
	}
</style>